import { memo } from 'react';

import { UserFilter } from '../../../../components/PageFilters/filters/UserFilter';
import type { PageFilterProps } from '../../../../components/PageFilters/types';

export const ownerFilterKey = 'workspace-owner-filter';

export const OwnerFilter = memo((props: PageFilterProps<string>) => {
  return <UserFilter {...props} label="Filter by owner" readableValuePrefix="Owner" />;
});
